import { render } from "./venueManage.vue?vue&type=template&id=173a7ea2"
import script from "./venueManage.vue?vue&type=script&lang=js"
export * from "./venueManage.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/aiProduct/venueManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "173a7ea2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('173a7ea2', __exports__)) {
    console.log('reload')
    api.reload('173a7ea2', __exports__)
  }
  
  module.hot.accept("./venueManage.vue?vue&type=template&id=173a7ea2", () => {
    console.log('re-render')
    api.rerender('173a7ea2', render)
  })

}


export default __exports__